import ClipboardJS from "clipboard"

class CopyLink{
    constructor(){
        this.clipboard = new ClipboardJS('.js-copy-value')
        this.btns = document.querySelectorAll('.js-copy-value')
        this.event()
    }

    event(){
        document.addEventListener('DOMContentLoaded', () => {
            this.btns.forEach(el => {
                el.addEventListener('mouseleave', this.clearTooltip(el))
            })
        })

        this.clipboard.on('success', e => {
            this.showTooltip(e.trigger);
        });
    }

    // Remove .tooptip class by mouseout
    clearTooltip(e){
        e.setAttribute('class','bl-snsShare__links__link js-copy-value')
    }

    // Add .tooltip class when it's clicked
    showTooltip(elem){
        elem.setAttribute('class','bl-snsShare__links__link js-copy-value tooltip')
    }
}
export default CopyLink;